/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo, useState } from 'react'
import { useThree } from '@react-three/fiber';

import { const_var, params } from '../../../../../../../redux/reducers/reducer';
import { controls } from '../../../../../../../redux/reducers/common/eventReducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../utils/Functions';
import useMouseEvents from '../../../../../../../hooks/useMouseEvents';
import { CSG } from '../../../../../../../assets/libs/csg-lib';

import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../CustomMaterial';

const WallModel = () => {
    const { gl } = useThree ();

    const [frontWallCloseState, setFrontWallCloseState] = useState(0);
    const [backWallCloseState, setBackWallCloseState] = useState(0);
    const [leftWallCloseState, setLeftWallCloseState] = useState(0);
    const [rightWallCloseState, setRightWallCloseState] = useState(0);

    const wallThickness = 0.005;
    const cbFrontBackWallOffset = 0.155;
    const Temp_B_p_w = params.leanB_p_w - 0.3;
    // const offsetWithDoorThickness = 0.127;
        
    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false

     

    const dutchDelModelFront = useMemo(() => {
        const freeSpace = 1;
        let cornerFreeSpaceW = (Temp_B_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanB_p_h - ((params.b_l_t_r_pB / 12) * Temp_B_p_w) :  params.leanB_p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_back_lean && (params.p_b_c_b_b_f === "Half Dutch End" || params.p_b_c_b_b_f === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(Temp_B_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_b_f === "Half Dutch End") {
                model.lineTo(-(Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(Temp_B_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((Temp_B_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((Temp_B_p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.add_back_lean, Temp_B_p_w, params.leanB_p_h, params.p_b_c_b_b_f])

    const dutchDelModelBack = useMemo(() => {
        const freeSpace = 1;
        let cornerFreeSpaceW = (Temp_B_p_w - freeSpace) / 6;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.leanB_p_h - ((params.b_l_t_r_pB / 12) * Temp_B_p_w) :  params.leanB_p_h
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6 
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = freeSpace * 2;

        if (cornerFreeSpaceW > freeSpace) cornerFreeSpaceW = freeSpace * 2;
        
        if (params.add_back_lean && (params.p_b_c_b_b_b === "Half Dutch End" || params.p_b_c_b_b_b === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(Temp_B_p_w / 2 - freeSpace), 0);

            if (params.p_b_c_b_b_b === "Half Dutch End") {
                model.lineTo(-(Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(Temp_B_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((Temp_B_p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
            } else {
                model.lineTo(-(Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((Temp_B_p_w / 2 - freeSpace), leftHeight - freeSpace);
            }
            model.lineTo((Temp_B_p_w / 2 - freeSpace), 0);

            return model;
        } else {
            return []
        }
    }, [params.add_back_lean, Temp_B_p_w, params.leanB_p_h, params.p_b_c_b_b_b])
    
    const GableFrontWallModelObj = useMemo(() => {
        if(params.p_b_c_b_b_f === 'Open') return;
        
        let regularHeight;
        if(params.p_r_s === 1) regularHeight = const_var.roofRegularDst * 2;
        else regularHeight = 0

        let innerModel;
        let outerModel;
        let wainscotModel;

        // inner wall model
        const createModel = (cornerValue) => {
            const model = new THREE.Shape();
            
            if(params.p_r_s === 1){
                model.moveTo(-params.leanB_p_w / 2, params.leanB_p_h);
                model.lineTo(-params.leanB_p_w / 2 + 0.01, params.leanB_p_h + const_var.roofRegularDst);
                model.quadraticCurveTo(
                    -params.leanB_p_w / 2 + 0.02, params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10,
                    -params.leanB_p_w / 2 + 0.01 + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12
                );
                model.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w/2)) + const_var.roofRegularDst * 2 - 0.03);
        
                model.lineTo(params.leanB_p_w / 2 - 0.01 - const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12);
                model.quadraticCurveTo(
                    params.leanB_p_w / 2 - 0.01, params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10,
                    params.leanB_p_w / 2 - 0.01, params.leanB_p_h + const_var.roofRegularDst
                );
                model.lineTo(params.leanB_p_w / 2 - 0.01, params.leanB_p_h);
                model.lineTo(params.leanB_p_w / 2 + 0.005, cornerValue || 0);
                model.lineTo(-params.leanB_p_w / 2 + 0.005, cornerValue || 0);
                model.closePath();
            } else {
                model.moveTo(-(Temp_B_p_w / 2 + cbFrontBackWallOffset), cornerValue || 0);
                model.lineTo(-(Temp_B_p_w / 2 + cbFrontBackWallOffset), params.leanB_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
                model.lineTo(0, params.leanB_p_h + (params.b_l_t_r_pB / 12) * (Temp_B_p_w / 2 + 0.1) + regularHeight);
                model.lineTo((Temp_B_p_w / 2 + cbFrontBackWallOffset), params.leanB_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
                model.lineTo((Temp_B_p_w / 2 + cbFrontBackWallOffset), cornerValue || 0);
                model.closePath();
            }

            return model;
        }

        let innerWallPanelValue = (frontWallCloseState < 0) ? params.leanB_p_h + regularHeight : frontWallCloseState;

        const innerWallModel = createModel(frontWallCloseState);
        const innerWallCutModel = createModel(innerWallPanelValue);

        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const meshInnerWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanFront', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
    
        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.position.set(-0.017, 0, -(params.p_d / 2 + params.leanB_p_d - wallThickness * 2) + 0.05);
        meshInnerWallModel_Temp.updateMatrixWorld();
    
        let meshInnerDelModel_Temp = meshInnerWallDelModel.clone();
        meshInnerDelModel_Temp.position.set(-params.leanB_p_pos, 0, -(params.p_d / 2 + params.leanB_p_d - 0.5));
        meshInnerDelModel_Temp.rotation.y = Math.PI;
        meshInnerDelModel_Temp.updateMatrixWorld();
    
        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const meshInnerWallDelModel_CSG = CSG.fromMesh(meshInnerDelModel_Temp);
    
        const innerWallModel_CSG = meshInnerWallModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const CSGInnerWallModel = CSG.toMesh(
            innerWallModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGInnerWallModel.geometry;
    
        // outer wall model
        const verticalDepth = Temp_B_p_w + cbFrontBackWallOffset * 2
        const horizontalDepth = Temp_B_p_w + cbFrontBackWallOffset * 2
        const VSPosition = -Temp_B_p_w / 2 - cbFrontBackWallOffset
        const HSPosition = Temp_B_p_w / 2 + cbFrontBackWallOffset
    
        const verticalHorizontalPosS =
            {
                "x": HSPosition,
                "y": (params.p_w_c_n && (params.p_b_c_b_b_f === 'Close') ? 2.935 : 0),
                "z": -(params.p_d / 2 + params.leanB_p_d + wallThickness)
            }
        const verticalHorizontalRotS =
            {
                "x": 0,
                "y": -Math.PI / 2,
                "z": Math.PI / 2
            }
        const patternLengthS = params.leanB_p_h + params.b_l_t_r_pB / 12 * Temp_B_p_w / 2 + regularHeight + (params.p_w_c_n && (params.p_b_c_b_b_f === 'Close') ? -2.935 : 0)
        const patternDepthS = horizontalDepth
        
        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS, isPattern), extrudeSettings(patternDepthS)));
        const meshOuterWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallCutModel, extrudeSettings(1)))
        
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        let meshOuterWallDelModel_Temp = meshOuterWallDelModel.clone();
        meshOuterWallDelModel_Temp.position.set(0, 0, -(params.p_d / 2 + params.leanB_p_d + 0.5));
        meshOuterWallDelModel_Temp.updateMatrixWorld();
    
        const meshOuterWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterWallDelModel_CSG = CSG.fromMesh(meshOuterWallDelModel_Temp);
    
        const outerWallModel_CSG = meshOuterWallModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const meshOuterWallDel_CSG = outerWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const CSGOuterWallModel = CSG.toMesh(meshOuterWallDel_CSG,new THREE.Matrix4());

        outerModel = CSGOuterWallModel.geometry;

        // wainscot wall model
        const wainscotVerticalHorizontalPosS = 
            {
                "x": HSPosition,
                "y" : 0,
                "z" : -(params.p_d / 2 + params.leanB_p_d + wallThickness * 2)
            }
        const wainscotVerticalHorizontalRotS = 
            {
                "x": 0,
                "y": -Math.PI / 2,
                "z": Math.PI / 2
            }
        const lengthPatternS = 3
        const depthPatternS = patternDepthS

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS, isPattern), extrudeSettings(depthPatternS)))
        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        const WainscotWallModel_CSG = meshWainscotWallModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const WainscotWallModelCSG = WainscotWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const CSGWainscotWallModel = CSG.toMesh(
            WainscotWallModelCSG,
            new THREE.Matrix4()
        )

        wainscotModel = CSGWainscotWallModel.geometry;

        return {innerModel, outerModel, wainscotModel}

    }, [params.wallTexture, params.leanB_p_pos, params.p_v_w, params.p_w, params.p_d, params.b_l_t_r_pB, Temp_B_p_w, params.p_r_s, params.leanB_p_d, params.leanB_p_h, frontWallCloseState, params.add_storage_check_back, params.add_storage_back, const_var.newDoorsArray,params.p_b_c_b_b_f, params.p_w_c_n, isPattern]);

    const GableBackWallModelObj = useMemo(() => {
        if(params.p_b_c_b_b_b === 'Open') return;
        let regularHeight;
        if(params.p_r_s === 1) regularHeight = const_var.roofRegularDst * 2;
        else regularHeight = 0

        let innerModel;
        let outerModel;
        let wainscotModel;

        // inner wall model
        const createModel = (cornerValue) => {
            const model = new THREE.Shape();
            
            if(params.p_r_s === 1){
                model.moveTo(-params.leanB_p_w / 2, params.leanB_p_h);
                model.lineTo(-params.leanB_p_w / 2 + 0.01, params.leanB_p_h + const_var.roofRegularDst);
                model.quadraticCurveTo(
                    -params.leanB_p_w / 2 + 0.02, params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10,
                    -params.leanB_p_w / 2 + 0.01 + const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12
                );
                model.lineTo(0, params.leanB_p_h + ((params.b_l_t_r_pB / 12) * (params.leanB_p_w/2)) + const_var.roofRegularDst * 2 - 0.03);
        
                model.lineTo(params.leanB_p_w / 2 - 0.01 - const_var.roofRegularDst, params.leanB_p_h + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.b_l_t_r_pB / 12);
                model.quadraticCurveTo(
                    params.leanB_p_w / 2 - 0.01, params.leanB_p_h + const_var.roofRegularDst * 1.8 + (const_var.roofRegularDst * params.b_l_t_r_pB / 12) / 10,
                    params.leanB_p_w / 2 - 0.01, params.leanB_p_h + const_var.roofRegularDst
                );
                model.lineTo(params.leanB_p_w / 2 - 0.01, params.leanB_p_h);
                model.lineTo(params.leanB_p_w / 2 + 0.005, cornerValue || 0);
                model.lineTo(-params.leanB_p_w / 2 + 0.005, cornerValue || 0);
                model.closePath();
            } else{
                model.moveTo(-(Temp_B_p_w / 2 + cbFrontBackWallOffset - 0.01), cornerValue || 0);
                model.lineTo(-(Temp_B_p_w / 2 + cbFrontBackWallOffset - 0.01), params.leanB_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
                model.lineTo(0, params.leanB_p_h + (params.b_l_t_r_pB / 12) * (Temp_B_p_w / 2 + 0.1) + regularHeight);
                model.lineTo((Temp_B_p_w / 2 + cbFrontBackWallOffset - 0.01), params.leanB_p_h + (params.p_r_s !== 1 && -0.02) + regularHeight);
                model.lineTo((Temp_B_p_w / 2 + cbFrontBackWallOffset - 0.01), cornerValue || 0);
                model.closePath();
            }

            return model;
        }

        let innerWallPanelValue = (backWallCloseState < 0) ? params.leanB_p_h + regularHeight : backWallCloseState;

        const innerWallModel = createModel(backWallCloseState);
        const innerWallCutModel = createModel(innerWallPanelValue);

        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const meshInnerWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
    
        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.position.set(-0.02, 0, -(params.p_d / 2 + cbFrontBackWallOffset + 0.1));
        meshInnerWallModel_Temp.updateMatrixWorld();

        let meshInnerDelModel_Temp = meshInnerWallDelModel.clone();
        meshInnerDelModel_Temp.position.set( -params.leanB_p_pos, 0, -(params.p_d / 2 + cbFrontBackWallOffset + 0.5));
        meshInnerDelModel_Temp.updateMatrixWorld();
    
        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const meshInnerWallDelModel_CSG = CSG.fromMesh(meshInnerDelModel_Temp);
 
        const innerWallModel_CSG = meshInnerWallModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const CSGInnerWallModel = CSG.toMesh(
            innerWallModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGInnerWallModel.geometry;
    
        // outer wall model
        const verticalDepth = Temp_B_p_w + cbFrontBackWallOffset * 2
        const horizontalDepth = Temp_B_p_w + cbFrontBackWallOffset * 2
        const VSPosition = Temp_B_p_w / 2 + cbFrontBackWallOffset
        const HSPosition = -Temp_B_p_w / 2 - cbFrontBackWallOffset
    
        const verticalHorizontalPosS = 
            {
                "x": HSPosition,
                "y": (params.p_w_c_n && (params.p_b_c_b_b_b === 'Close') ? 2.935 : 0),
                "z": -(params.p_d / 2 + cbFrontBackWallOffset + 0.06)
            }
        const verticalHorizontalRotS = 
            {
                "x": 0,
                "y": Math.PI / 2,
                "z": Math.PI / 2
            }
        const patternLengthS = params.leanB_p_h + params.b_l_t_r_pB / 12 * Temp_B_p_w / 2 + regularHeight + (params.p_w_c_n && (params.p_b_c_b_b_b === 'Close') ? -2.935 : 0)
        const patternDepthS = horizontalDepth
        
        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS, isPattern), extrudeSettings(patternDepthS)));
        const meshOuterWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallCutModel, extrudeSettings(1)))
        
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        let meshOuterWallDelModel_Temp = meshOuterWallDelModel.clone();
        meshOuterWallDelModel_Temp.position.set(0, 0, -(params.p_d / 2 + 0.5));
        meshOuterWallDelModel_Temp.updateMatrixWorld();
    
        const meshOuterWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterWallDelModel_CSG = CSG.fromMesh(meshOuterWallDelModel_Temp);

        const outerWallModel_CSG = meshOuterWallModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const meshOuterWallDel_CSG = outerWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const CSGOuterWallModel = CSG.toMesh(meshOuterWallDel_CSG,new THREE.Matrix4());

        outerModel = CSGOuterWallModel.geometry;

        // wainscot wall model
        const wainscotVerticalHorizontalPosS = 
            {
                "x": HSPosition,
                "y" : 0,
                "z" : -(params.p_d / 2 + cbFrontBackWallOffset + 0.06)
            }
        const wainscotVerticalHorizontalRotS = 
            {
                "x": 0,
                "y": Math.PI / 2,
                "z": Math.PI / 2
            }
        const lengthPatternS = 3
        const depthPatternS = patternDepthS

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS, isPattern), extrudeSettings(depthPatternS)))
        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        const WainscotWallModel_CSG = meshWainscotWallModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const WainscotWallModelCSG = WainscotWallModel_CSG.intersect(meshOuterWallDelModel_CSG);
        const CSGWainscotWallModel = CSG.toMesh(
            WainscotWallModelCSG,
            new THREE.Matrix4()
        )

        wainscotModel = CSGWainscotWallModel.geometry;

        return {innerModel, outerModel, wainscotModel}

    }, [params.wallTexture, params.leanB_p_pos, params.p_v_w, params.p_w, params.p_d, params.b_l_t_r_pB, Temp_B_p_w, params.p_r_s, params.leanB_p_d, params.leanB_p_h, backWallCloseState, params.add_storage_check_back, params.add_storage_back, const_var.newDoorsArray,params.p_b_c_b_b_b, params.p_w_c_n, isPattern]);

    const GableRightWallModelObj = useMemo(() => {
        if(params.p_b_c_b_b_r === 'Open') return;

        let outerModel;
        let innerModel;
        let wainscotModel;

        // inner wall model
        const innerWallModel = new THREE.Shape();
        if (params.p_b_c_b_b_r !== 'Open' || typeof(params.p_b_c_b_b_r) === 'object') {
            innerWallModel.moveTo(-params.leanB_p_d + 0.15 + 0.005, params.leanB_p_h);
            innerWallModel.lineTo(0, params.leanB_p_h);
            innerWallModel.lineTo(0, rightWallCloseState + (params.p_r_s === 1 && 0.1));
            innerWallModel.lineTo(-params.leanB_p_d + 0.15 + 0.005, rightWallCloseState + (params.p_r_s === 1 && 0.1));
            innerWallModel.closePath();
        }

        const innerWallPanelValue = (params.p_r_s === 1) ? rightWallCloseState + 0.1 : rightWallCloseState

        const innerWallCutModel = new THREE.Shape();
        innerWallCutModel.moveTo(-(params.p_d / 2), params.leanB_p_h); //right lean left top
        innerWallCutModel.lineTo(-(params.p_d / 2 + params.leanB_p_d), params.leanB_p_h); //right lean right top
        innerWallCutModel.lineTo(-(params.p_d / 2 + params.leanB_p_d), innerWallPanelValue); //right lean right bottom
        innerWallCutModel.lineTo(-(params.p_d / 2), innerWallPanelValue); //right lean left bottom
        innerWallCutModel.closePath();

        const storageLeftWallModel = new THREE.Shape();
        storageLeftWallModel.moveTo(-0.155, params.leanB_p_h);                         
        storageLeftWallModel.lineTo(-parseInt(params.add_storage_back), params.leanB_p_h);      
        storageLeftWallModel.lineTo(-parseInt(params.add_storage_back), 0); 
        storageLeftWallModel.lineTo(-0.155, 0);                    
        storageLeftWallModel.closePath();
        
        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const storageLeftWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageLeftWallModel, extrudeSettings(1)))
        const meshInnerWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanRight', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshInnerWallDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelBack, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.position.set(-Temp_B_p_w / 2 - cbFrontBackWallOffset + wallThickness + 0.05, 0, -(params.p_d / 2 + 0.16));
        meshInnerWallModel_Temp.rotation.set(0, -Math.PI / 2, 0);
        meshInnerWallModel_Temp.updateMatrixWorld();

        let storageLeftWallDelModel_Temp = storageLeftWallDelModel.clone();
        storageLeftWallDelModel_Temp.position.set(Temp_B_p_w / -2 - cbFrontBackWallOffset + wallThickness + 0.5, 0, -params.p_d / 2 - params.backLeanStoragePosition);
        storageLeftWallDelModel_Temp.rotation.set(0, -Math.PI / 2, 0);
        storageLeftWallDelModel_Temp.updateMatrixWorld();
    
        let meshInnerDelModel_Temp = meshInnerWallDelModel.clone();
        meshInnerDelModel_Temp.position.set(Temp_B_p_w / -2 -cbFrontBackWallOffset + wallThickness - 0.5, 0, 0);
        meshInnerDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshInnerDelModel_Temp.updateMatrixWorld();

        let meshInnerWallDutchDelModel_Temp = meshInnerWallDutchDelModel.clone();
        meshInnerWallDutchDelModel_Temp.position.set(-Temp_B_p_w / 2 - cbFrontBackWallOffset + wallThickness - 0.5, 0, -params.p_d / 2);
        meshInnerWallModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshInnerWallDutchDelModel_Temp.updateMatrixWorld();

        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const storageLeftWallDelModel_CSG = CSG.fromMesh(storageLeftWallDelModel_Temp);
        const meshInnerDelModel_CSG = CSG.fromMesh(meshInnerDelModel_Temp);
        const meshInnerWallDutchDelModel_CSG = CSG.fromMesh(meshInnerWallDutchDelModel_Temp);

        let meshInnerStorageDelModel_CSG;
        if(params.add_storage_check_back){
            meshInnerStorageDelModel_CSG = meshInnerWallModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            meshInnerStorageDelModel_CSG = meshInnerWallModel_CSG
        }

        const innerWallModel_CSG = meshInnerStorageDelModel_CSG.subtract(meshInnerDelModel_CSG);
        const meshInnerWallModelCSG = innerWallModel_CSG.subtract(meshInnerWallDutchDelModel_CSG);

        const CSGLeftWallModel = CSG.toMesh(
            meshInnerWallModelCSG,
            new THREE.Matrix4()
        )
    
        innerModel = CSGLeftWallModel.geometry;

        // outer wall model
        const verticalHorizontalPos = 
            {
                "x": Temp_B_p_w / -2 - cbFrontBackWallOffset - 0.0025,
                "y": params.p_w_c_n && params.p_b_c_b_b_r === 'Close' ? 2.935 : 0,
                "z": -(params.p_d / 2 + params.leanB_p_d)
            }
        const verticalHorizontalRot =
            {
                "x": 0,
                "y": 0,
                "z": Math.PI / 2
            }
        const patternLength = params.leanB_p_h + (params.p_w_c_n && params.p_b_c_b_b_r === 'Close' ? -2.935 : 0)
        const patternDepth = params.leanB_p_d - cbFrontBackWallOffset

        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength, isPattern), extrudeSettings(patternDepth)))  
        const meshOuterWallGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallCutModel, extrudeSettings(1)))
    
        let meshOuterWallGableDelModel_Temp = meshOuterWallGableDelModel.clone();
        meshOuterWallGableDelModel_Temp.position.set(Temp_B_p_w / -2 - cbFrontBackWallOffset + 0.5, 0, 0);
        meshOuterWallGableDelModel_Temp.rotation.set(0, -Math.PI / 2, 0);
        meshOuterWallGableDelModel_Temp.updateMatrixWorld();
    
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        const mesOuterhWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterGableDelModel_CSG = CSG.fromMesh(meshOuterWallGableDelModel_Temp);     
        
        let meshOuterStorageDelModel_CSG;
        if(params.add_storage_check_back){
            meshOuterStorageDelModel_CSG = mesOuterhWallModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            meshOuterStorageDelModel_CSG = mesOuterhWallModel_CSG
        }
    
        const outerWallModel_CSG = meshOuterStorageDelModel_CSG.subtract(meshInnerDelModel_CSG);
        const outerWallGableModel_CSG = outerWallModel_CSG.intersect(meshOuterGableDelModel_CSG);
        const MeshtOuterWallModel_CSG = outerWallGableModel_CSG.subtract(meshInnerWallDutchDelModel_CSG);

        const CSGOuterWallModel = CSG.toMesh(MeshtOuterWallModel_CSG,new THREE.Matrix4());

        outerModel = CSGOuterWallModel.geometry;

        // wainscot wall model
        const wainscotVerticalHorizontalPos = 
            {
                "x": Temp_B_p_w / -2 - cbFrontBackWallOffset - 0.0025,
                "y": 0,
                "z": -(params.p_d / 2 + params.leanB_p_d)
            }
        const wainscotVerticalHorizontalRot = 
            {
                "x": 0,
                "y": 0,
                "z": Math.PI / 2
            }

        const lengthPattern = 3
        const depthPattern = patternDepth

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern, isPattern), extrudeSettings(depthPattern)))
        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshBackWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        let meshWainscotStorageDelModel_CSG;
        if(params.add_storage_check_back){
            meshWainscotStorageDelModel_CSG = meshBackWainscotWallModel_CSG.subtract(storageLeftWallDelModel_CSG);
        } else{
            meshWainscotStorageDelModel_CSG = meshBackWainscotWallModel_CSG
        }

        const wainscotWallModel_CSG = meshWainscotStorageDelModel_CSG.subtract(meshInnerDelModel_CSG);
        const wainscotWallModelCSG = wainscotWallModel_CSG.subtract(meshInnerWallDutchDelModel_CSG);

        const CSGBackWainscotModel = CSG.toMesh(
            wainscotWallModelCSG,
            new THREE.Matrix4()
        )

        wainscotModel = CSGBackWainscotModel.geometry;

        return {innerModel, outerModel, wainscotModel}
    }, [params.wallTexture,rightWallCloseState, params.add_storage_check_back, params.backLeanStoragePosition, params.add_storage_back, params.p_v_w, params.p_h, params.p_w, params.p_d, params.p_r_p, params.leanB_p_pos, cbFrontBackWallOffset, params.p_b_c_b_b_r, params.p_r_s, Temp_B_p_w, params.leanB_p_d, params.b_l_t_r_pB, params.leanB_p_h, rightWallCloseState, const_var.newDoorsArray, params.p_w_c_n, isPattern]);

    const GableLeftWallModelObj = useMemo(() => {
        if(params.p_b_c_b_b_l === 'Open') return;

        let outerModel;
        let innerModel;
        let wainscotModel;

        // inner wall model
        const innerWallModel = new THREE.Shape();

        if (params.p_b_c_b_b_l !== 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            innerWallModel.moveTo(-params.leanB_p_d + cbFrontBackWallOffset + 0.015, params.leanB_p_h);
            innerWallModel.lineTo(0, params.leanB_p_h);
            innerWallModel.lineTo(0, leftWallCloseState + (params.p_r_s === 1 && 0.1));
            innerWallModel.lineTo(-params.leanB_p_d + cbFrontBackWallOffset + 0.015, leftWallCloseState + (params.p_r_s === 1 && 0.1));
            innerWallModel.closePath();
        };

        let innerWallPanelValue = (params.p_r_s === 1) ? leftWallCloseState + 0.1 : leftWallCloseState

        const innerWallCutModel = new THREE.Shape();

        innerWallCutModel.moveTo(0, params.leanB_p_h);                           //right lean left top
        innerWallCutModel.lineTo(-params.leanB_p_d, params.leanB_p_h);         //right lean right top
        innerWallCutModel.lineTo(-params.leanB_p_d, innerWallPanelValue);     //right lean right bottom
        innerWallCutModel.lineTo(0, innerWallPanelValue);                       //right lean left bottom
        innerWallCutModel.closePath();

        const storageRightWallModel = new THREE.Shape();
        storageRightWallModel.moveTo(-0.155, params.leanB_p_h);                          
        storageRightWallModel.lineTo(-parseInt(params.add_storage_back), params.leanB_p_h);        
        storageRightWallModel.lineTo(-parseInt(params.add_storage_back), 0);  
        storageRightWallModel.lineTo(-0.155, 0);                    
        storageRightWallModel.closePath();

        const meshInnerWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallModel, extrudeSettings(0.005)));
        const storageRightWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageRightWallModel, extrudeSettings(1)));
        const meshInnerWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('gableBackLeanLeft', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshInnerWallDutchDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(dutchDelModelFront, extrudeSettings(1)), new THREE.MeshStandardMaterial({color: 'blue'}))

        let meshInnerWallModel_Temp = meshInnerWallModel.clone();
        meshInnerWallModel_Temp.position.set(Temp_B_p_w / 2 + cbFrontBackWallOffset - wallThickness * 2 - 0.05, 0, -(params.p_d / 2 + cbFrontBackWallOffset - 0.015));
        meshInnerWallModel_Temp.rotation.set(0, -Math.PI / 2, 0);
        meshInnerWallModel_Temp.updateMatrixWorld();

        let storageRightWallDelModel_Temp = storageRightWallDelModel.clone();
        storageRightWallDelModel_Temp.position.set(Temp_B_p_w / 2 + cbFrontBackWallOffset - wallThickness * 2 + 0.5, 0, -params.p_d / 2 - params.backLeanStoragePosition);
        storageRightWallDelModel_Temp.rotation.set(0, -Math.PI / 2, 0);
        storageRightWallDelModel_Temp.updateMatrixWorld();
    
        let meshInnerWallDelModel_Temp = meshInnerWallDelModel.clone();
        meshInnerWallDelModel_Temp.position.set(Temp_B_p_w / 2 - 0.5, 0, 0);
        meshInnerWallDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshInnerWallDelModel_Temp.updateMatrixWorld();

        let meshInnerWallDutchDelModel_Temp = meshInnerWallDutchDelModel.clone();
        meshInnerWallDutchDelModel_Temp.position.set(Temp_B_p_w / 2 - 0.5,0, -params.p_d / 2);
        meshInnerWallDutchDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshInnerWallDutchDelModel_Temp.updateMatrixWorld();
    
        const meshInnerWallModel_CSG = CSG.fromMesh(meshInnerWallModel_Temp);
        const storageRightWallDelModel_CSG = CSG.fromMesh(storageRightWallDelModel_Temp);
        const meshInnerWallDelModel_CSG = CSG.fromMesh(meshInnerWallDelModel_Temp);
        const meshInnerWallDutchDelModel_CSG = CSG.fromMesh(meshInnerWallDutchDelModel_Temp);

        let meshInnerStorageDelModel_CSG;
        if(params.add_storage_check_back){
            meshInnerStorageDelModel_CSG = meshInnerWallModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else{
            meshInnerStorageDelModel_CSG = meshInnerWallModel_CSG
        }
    
        const innerWallModel_CSG = meshInnerStorageDelModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const innerWallModelCSG = innerWallModel_CSG.subtract(meshInnerWallDutchDelModel_CSG);

        const CSGFrontWallModel = CSG.toMesh(
            innerWallModelCSG,
            new THREE.Matrix4()
        )
    
        innerModel = CSGFrontWallModel.geometry;

        // outer wall model
        const patternLength = params.leanB_p_h + (params.p_w_c_n && params.p_b_c_b_b_l === 'Close' ? -2.935 : 0)
        const patternDepth = params.leanB_p_d - cbFrontBackWallOffset
        const verticalHorizontalPos = 
            {
                "x": Temp_B_p_w / 2 + cbFrontBackWallOffset,
                "y": params.p_w_c_n && params.p_b_c_b_b_l === 'Close' ? 2.935 : 0,
                "z": -(params.p_d / 2 + cbFrontBackWallOffset)
            }
        const verticalHorizontalRot = 
            {
                "x": 0,
                "y": Math.PI,
                "z": Math.PI / 2
            }
        const lengthPattern = 3;
        const depthPattern = patternDepth;

        const meshOuterWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLength, isPattern), extrudeSettings(patternDepth)))  
        const meshOuterWallGableDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(innerWallCutModel, extrudeSettings(1)))
    
        let meshOuterWallGableDelModel_Temp = meshOuterWallGableDelModel.clone();
        meshOuterWallGableDelModel_Temp.position.set(Temp_B_p_w / 2 - 0.5, 0, -params.p_d / 2 - params.leanB_p_d);
        meshOuterWallGableDelModel_Temp.rotation.set(0, Math.PI / 2, 0);
        meshOuterWallGableDelModel_Temp.updateMatrixWorld();
    
        let meshOuterWallModel_Temp = meshOuterWallModel.clone();
        meshOuterWallModel_Temp.position.set(verticalHorizontalPos.x,verticalHorizontalPos.y,verticalHorizontalPos.z);
        meshOuterWallModel_Temp.rotation.set(verticalHorizontalRot.x,verticalHorizontalRot.y,verticalHorizontalRot.z);
        meshOuterWallModel_Temp.updateMatrixWorld();
    
        const meshOuterWallModel_CSG = CSG.fromMesh(meshOuterWallModel_Temp);
        const meshOuterWallGableDelModel_CSG = CSG.fromMesh(meshOuterWallGableDelModel_Temp);

        let meshOuterStorageDelModel_CSG;
        if(params.add_storage_check_back){
            meshOuterStorageDelModel_CSG = meshOuterWallModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else{
            meshOuterStorageDelModel_CSG = meshOuterWallModel_CSG
        }
    
        const outerWallModel_CSG = meshOuterStorageDelModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const oueterWallGableModel_CSG = outerWallModel_CSG.intersect(meshOuterWallGableDelModel_CSG);
        const outerWallModelCSG = oueterWallGableModel_CSG.subtract(meshInnerWallDutchDelModel_CSG);

        const CSGWallModel = CSG.toMesh(outerWallModelCSG,new THREE.Matrix4());

        outerModel = CSGWallModel.geometry;
        
        // wainscot wall model
        const wainscotVerticalHorizontalPos = 
            {
                "x": Temp_B_p_w / 2 + 0.16,
                "y": 0,
                "z": -(params.p_d / 2 + cbFrontBackWallOffset)
            }
        const wainscotVerticalHorizontalRot = 
            {
                "x": 0,
                "y": Math.PI,
                "z": Math.PI / 2
            }

        const meshWainscotWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPattern, isPattern), extrudeSettings(depthPattern)))

        let meshWainscotWallModel_Temp = meshWainscotWallModel.clone();
        meshWainscotWallModel_Temp.position.set(wainscotVerticalHorizontalPos.x,wainscotVerticalHorizontalPos.y,wainscotVerticalHorizontalPos.z);
        meshWainscotWallModel_Temp.rotation.set(wainscotVerticalHorizontalRot.x,wainscotVerticalHorizontalRot.y,wainscotVerticalHorizontalRot.z);
        meshWainscotWallModel_Temp.updateMatrixWorld();

        const meshWainscotWallModel_CSG = CSG.fromMesh(meshWainscotWallModel_Temp);

        let meshWainscotStorageDelModel_CSG;
        if(params.add_storage_check_back){
            meshWainscotStorageDelModel_CSG = meshWainscotWallModel_CSG.subtract(storageRightWallDelModel_CSG);
        } else{
            meshWainscotStorageDelModel_CSG = meshWainscotWallModel_CSG
        }

        const wainscotWallModel_CSG = meshWainscotStorageDelModel_CSG.subtract(meshInnerWallDelModel_CSG);
        const wainscotWallModelCSG = wainscotWallModel_CSG.subtract(meshInnerWallDutchDelModel_CSG);

        const CSGFrontWainscotModel = CSG.toMesh(
            wainscotWallModelCSG,
            new THREE.Matrix4()
        )

        wainscotModel = CSGFrontWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel};

    }, [params.wallTexture, params.p_w, params.p_h, params.p_d, params.add_storage_check_back, params.add_storage_back, params.backLeanStoragePosition, params.p_r_p, params.leanB_p_pos, params.leanB_p_d, params.p_b_c_b_b_l, params.p_r_s, Temp_B_p_w, params.leanB_p_h, params.b_l_t_r_pB, leftWallCloseState, const_var.newDoorsArray, params.p_w_c_n, params.p_v_w, isPattern]);    

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    // --- left wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_l === 'Open' || typeof(params.p_b_c_b_b_l) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_l === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_l === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_l === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_l === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_l;
        }
        // if(params.p_w_c_n && params.p_b_c_b_b_l === "Close") tempWallCloseSize = 3;
        setLeftWallCloseState(tempWallCloseSize);
    }, [params.add_storage_check_back, params.p_b_c_b_b_l, params.leanB_p_h, params.p_r_s, params.p_w_c_n])

    // --- right wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_r === 'Open' || typeof(params.p_b_c_b_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h;
            }
        } else if (params.p_b_c_b_b_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_r === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_r;
        }
        // if(params.p_w_c_n && params.p_b_c_b_b_r === "Close") tempWallCloseSize = 3;
        setRightWallCloseState(tempWallCloseSize);
    }, [params.add_storage_check_back, params.p_b_c_b_b_r, params.leanB_p_h, params.p_r_s, params.p_w_c_n])

    // --- front wall close state    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_b_f === 'Gable') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h - 0.2;
            }
        } else if (params.p_b_c_b_b_f === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_f === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_f === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_f === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanB_p_h - 3 * params.p_b_c_b_b_f;
        }

        // if(params.p_w_c_n && params.p_b_c_b_b_f === "Close") tempWallCloseSize = 3;

        setFrontWallCloseState(tempWallCloseSize);
    }, [params.p_b_c_b_b_f, params.leanB_p_h, params.p_r_s, params.p_w_c_n])

    // --- back wall close state
    useMemo(() => {
        let tempWallCloseSize;
        if (params.p_b_c_b_b_b === "Gable") {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanB_p_h - 0.25;
            } else {
                tempWallCloseSize = params.leanB_p_h - 0.2;
            }
        } else if (params.p_b_c_b_b_b === "One_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4 * 3;
        } else if (params.p_b_c_b_b_b === "Half_Close") {
            tempWallCloseSize = params.leanB_p_h / 2;
        } else if (params.p_b_c_b_b_b === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanB_p_h / 4;
        } else if (params.p_b_c_b_b_b === "Half Dutch End") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_b_b === "Half End") {
            tempWallCloseSize = 0;
        } else if (params.p_b_c_b_b_b === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = -1;
        }

        // if(params.p_w_c_n && params.p_b_c_b_b_b === "Close") tempWallCloseSize = 3;

        setBackWallCloseState(tempWallCloseSize);
    }, [params.p_b_c_b_b_b, params.leanB_p_h, params.p_r_s, params.p_w_c_n])

    const handleMouseEvent = (e) => {
        if (controls.isCheckActiveTab === 'doorwindow' && (const_var.focusedSection === "frontlean" && params.activeWall === "L_L_F_S_W")) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    return (
        <>
            <group name='front_wall' {...eventHandlers}>
                {params.p_b_c_b_b_f !== 'Open' && GableFrontWallModelObj?.outerModel &&
                    <mesh name="G_B_L_F_W_outer" geometry={GableFrontWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {params.p_w_c_n === true && params.p_b_c_b_b_f === "Close" && GableFrontWallModelObj?.wainscotModel &&
                    <mesh name="G_B_L_F_W_wainscot" geometry={GableFrontWallModelObj?.wainscotModel} position={[-0.005,0,0]}  renderOrder={1}>
                        <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {params.p_b_c_b_b_f !== 'Open' && GableFrontWallModelObj && GableFrontWallModelObj?.innerModel && 
                    <mesh name="G_B_L_F_W_inner" geometry={GableFrontWallModelObj?.innerModel} position={[wallThickness + 0.01, 0, 0]}>
                        <MaterialInnerWall texture={texture} visibleSection={"gableBackLean"} />
                    </mesh>
                }
            </group>
            {params.p_b_w !== 'Close' &&
                <group name='back_wall'>
                    {params.p_b_c_b_b_b !== 'Open' && GableBackWallModelObj?.outerModel &&
                        <mesh name="G_B_L_B_W_outer" geometry={GableBackWallModelObj?.outerModel} renderOrder={1}>
                            <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                        </mesh>
                    }
                    {params.p_w_c_n === true && params.p_b_c_b_b_b === "Close" && GableBackWallModelObj?.wainscotModel &&
                        <mesh name="G_B_L_B_W_wainscot" geometry={GableBackWallModelObj?.wainscotModel} position={[-0.005,0,0]}  renderOrder={1}>
                            <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                        </mesh>
                    }
                    {params.p_b_c_b_b_b !== "Open" && GableBackWallModelObj && GableBackWallModelObj?.innerModel && 
                        <mesh name="G_B_L_B_W_inner" geometry={GableBackWallModelObj?.innerModel} position={[wallThickness + 0.01, 0, 0]}>
                            <MaterialInnerWall texture={texture} visibleSection={"gableBackLean"} />
                        </mesh>
                    }
                </group>
            }
            <group name='left-wall'>
                {params.p_b_c_b_b_l !== 'Open' && GableLeftWallModelObj?.outerModel &&
                    <mesh name="G_B_L_L_W_outer" geometry={GableLeftWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {params.p_w_c_n === true && (params.p_b_c_b_b_l === "Close" || params.p_b_c_b_b_l === "Half Dutch End" || params.p_b_c_b_b_l === "Half End") && GableLeftWallModelObj?.wainscotModel &&
                    <mesh name="G_B_L_L_W_wainscot" geometry={GableLeftWallModelObj?.wainscotModel} position={[0,0,0.005]} renderOrder={1}>
                        <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {GableLeftWallModelObj && GableLeftWallModelObj?.innerModel &&
                    <mesh name="G_B_L_L_W_inner" geometry={GableLeftWallModelObj?.innerModel} position={[0, 0, -wallThickness * 3 - 0.01]}>
                        <MaterialInnerWall texture={texture} visibleSection={"gableBackLean"} />
                    </mesh>
                }
            </group>
            <group name='right-wall'>
                {params.p_b_c_b_b_r !== 'Open' && GableRightWallModelObj?.outerModel &&
                    <mesh name="G_B_L_R_W_outer" geometry={GableRightWallModelObj?.outerModel} renderOrder={1}>
                        <MaterialOuterWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {params.p_w_c_n === true && (params.p_b_c_b_b_r === "Close" || params.p_b_c_b_b_r === "Half Dutch End" || params.p_b_c_b_b_r === "Half End") && GableRightWallModelObj?.wainscotModel &&
                    <mesh name="G_B_L_R_W_wainscot" geometry={GableRightWallModelObj?.wainscotModel} position={[0,0,-0.005]} renderOrder={1}>
                        <MaterialWainScotWallNew isPattern={isPattern}   visibleSection={"gableBackLean"} />
                    </mesh>
                }
                {GableRightWallModelObj && GableRightWallModelObj?.innerModel &&
                    <mesh name="G_B_L_R_W_inner" geometry={GableRightWallModelObj?.innerModel} position={[0.005, 0, wallThickness + 0.01]}>
                        <MaterialInnerWall texture={texture} visibleSection={"gableBackLean"} />
                    </mesh>
                }
            </group>
        </>
    )
}

export default WallModel